import {getTokenByUsername} from "@/api/im.js"
import Vue from "vue";


const im = {
  state: {
    imUser: '',
    unreadCount: 0,
  },
  mutations: {
    SET_IM_USER(state, user) {
      state.imUser = user
    },
    SET_UNREAD_COUNT(state, count) {
      state.unreadCount = count
    },
  },
  actions: {
    updateUnreadCount({commit}, count) {
      commit('SET_UNREAD_COUNT', count)
    },
    //  获取用户消息
    async getImInfo({commit,rootGetters,dispatch}) {
      let user = 'admin';
      user = user + rootGetters.userId
      let payload = {
        user,
        pwd: user,
      }
      commit('SET_IM_USER',user)
      let appkey = Vue.prototype.$webIM.config.appkey
      let localAppkey = localStorage.getItem('localAppkey')
      if(appkey === localAppkey && localStorage.getItem('accessToken')&&user === localStorage.getItem('imUser')) {
        payload.accessToken = localStorage.getItem('accessToken');
      } else {
        let {data} = await getTokenByUsername({username: user})
        localStorage.setItem('accessToken', data)
        localStorage.setItem('imUser', user)
        localStorage.setItem('localAppkey', appkey)
        payload.accessToken =  data
      }
      if (!rootGetters.userId) {
        setTimeout(() => {
          dispatch('getImInfo')
        }, 1000)
      } else {
        dispatch('onLogin',payload)
      }
    },
    async onLogin({commit,dispatch,state},payload) {
      try {
        if(!payload.accessToken){
          return;
        }
        let options = {
          user: payload.user,
          accessToken: payload.accessToken,
          appKey: Vue.prototype.$webIM.config.appkey,
          apiUrl: 'https://a1.easecdn.com'
        };
        await Vue.prototype.$webIM.conn.open(options)
        dispatch('updateUser')
      } catch (err) {
        localStorage.removeItem('accessToken')
        //
        // if(err.type !== 208&&err.type !== 1) {
        //   localStorage.removeItem('accessToken')
        //   setTimeout(()=>{
        //     dispatch('getImInfo')
        //   },20000)
        // }
      }
    },
    // 更新用户属性
    async updateUser({rootGetters}) {
      let defaultName = process.env.NODE_ENV == "production"? "Customer Service" : "Dev Customer Service"
      let option = {
        nickname: rootGetters.name + '-' + defaultName,
        // nickname: '货主',
        avatarurl: rootGetters.icon || "",
      };
      await Vue.prototype.$webIM.conn.updateUserInfo(option).then((res) => {
      });
    },
  }
}

export default im



// WEBPACK FOOTER //
// ./src/store/modules/im.js